import { Card, FloatButton, Space, Typography } from "antd"
import { CloseOutlined, CustomerServiceOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons"
import { assembleFullName } from "../Tools/String"
import "../Application/ApplicationInterview.css"

const { Text, Link } = Typography

const LoanOfficerPanelV2 = ({ show, officer, onToggle, bottomOffset = 20 }) => {
    const { FirstName, MiddleName, LastName, Phone, Email, CompanyName } = officer || {}
    const fullName = assembleFullName(FirstName, MiddleName, LastName)

    return (
        <>
            {!show && (
                <FloatButton
                    icon={<CustomerServiceOutlined />}
                    type="primary"
                    onClick={() => onToggle(true)}
                    className="loan-officer-button"
                    style={{ bottom: bottomOffset }}
                />
            )}
            <Card
                className="loan-officer-card"
                style={{
                    transform: show ? "translateY(0)" : "translateY(150%)",
                    opacity: show ? 1 : 0,
                    bottom: bottomOffset,
                }}
                styles={{ body: { padding: "20px 16px" } }}
                bordered={false}
            >
                <CloseOutlined className="card-close-icon" onClick={() => onToggle(false)} />
                <Space direction="vertical" size="small" style={{ width: "100%", textAlign: "left" }}>
                    <Text style={{ fontWeight: 600, fontSize: 14, color: "#081265" }}>MY LOAN OFFICER</Text>
                    <Space direction="vertical" size={0} style={{ marginTop: 4, marginBottom: 10 }}>
                        <Text style={{ fontSize: 16, fontWeight: 600, display: "block", color: "#222222" }}>{fullName}</Text>
                        <Text style={{ fontSize: 14, fontWeight: 400, color: "#6E6E70" }}>{CompanyName}</Text>
                    </Space>
                    <Space direction="vertical" size="small" style={{ width: "100%" }}>
                        <Link href={`tel:${Phone}`} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <PhoneOutlined rotate={90} style={{ fontSize: 18, color: "#545F71" }} />
                            <Text style={{ fontSize: 16, fontWeight: 400, color: "#222222" }}>{Phone ? `${Phone}`.replace(/-/, "") : ""}</Text>
                        </Link>
                        <Link href={`mailto:${Email}`} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <MailOutlined style={{ fontSize: 18, color: "#545F71" }} />
                            <Text style={{ fontSize: 16, fontWeight: 400, color: "#325CEB" }}>{Email}</Text>
                        </Link>
                    </Space>
                </Space>
            </Card>
        </>
    )
}

export default LoanOfficerPanelV2
